import React, { useEffect, useState, useRef } from "react";
import { Link } from "react-router-dom";
import MenuItems from "./MenuItems";
import RightArrow from "../SVG";
import Logo from "../../assets/img/logo/logo_v1.png";
import svgImg1 from "../../assets/img/header/1.svg";
import svgImg2 from "../../assets/img/header/2.svg";
import AQUA from "../../assets/img/aqua_india_logo.png";
import LinkedIn from "../../assets/img/linkedin.png";
import Face from "../../assets/img/communication.png";
import WAS from "../../assets/img/WAS_LOGOFinal-02.png";
import { useAuth } from "../../context/AdminAuthContext";
import {
  ChevronDown,
  ChevronUp,
  Gauge,
  User,
  LogOut,
  X,
  Phone,
  MapPin,
} from "lucide-react";

const Header = (props) => {
  const { headerClass } = props;
  const [isOffCanvasOpen, setIsOffCanvasOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const { auth, logout } = useAuth();

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const toggleVisibility = () => {
      setIsVisible(window.scrollY > 400);
    };
    window.addEventListener("scroll", toggleVisibility);
    return () => window.removeEventListener("scroll", toggleVisibility);
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const getRoleDisplayText = () => {
    if (auth.role === "admin") return "Admin";
    if (auth.role === "maintainer") return "Maintainer";
    if (auth.role === "student") return "Student";
    return "Member";
  };

  return (
    <>
      <header className={headerClass ? headerClass : "it-header-height"}>
        <div
          className="ed-header-top-area black-bg-2"
          style={{ padding: "8px 0" }}
        >
          <div className="container">
            <div className="row py-2">
              <div className="col-xl-2 d-none d-xl-flex justify-content-center">
                <div
                  className="ed-header-top-5-social d-flex align-items-center"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "110%",
                  }}
                >
                  <a
                    target="_blank"
                    href="https://www.facebook.com/p/Society-of-Aquaculture-Professionals-100063913875757/"
                    rel="noreferrer"
                    style={{ fontSize: "10px" }}
                  >
                    <img
                      src={Face}
                      alt="Facebook"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </a>
                  <a
                    target="_blank"
                    href="https://www.linkedin.com/company/aquaprofessional"
                    rel="noreferrer"
                    style={{ fontSize: "10px" }}
                  >
                    <img
                      src={LinkedIn}
                      alt="LinkedIn"
                      style={{ width: "24px", height: "24px" }}
                    />
                  </a>
                </div>
              </div>

              <div className="col-xl-6 col-lg-6 col-md-6 d-none d-md-flex justify-content-md-end justify-content-center align-items-center text-white">
                <div className="text-white d-flex flex justify-content-center justify-content-md-end align-items-center">
                  <ul
                    style={{
                      margin: 0,
                      padding: 0,
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <li
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        padding: "0 8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <i>
                        <img
                          src={svgImg1}
                          alt=""
                          style={{ width: "14px", marginRight: "4px" }}
                        />
                      </i>
                      <a className="hover-anim" href="#">
                        +91 9790559513
                      </a>
                    </li>
                    <li
                      style={{
                        fontSize: "14px",
                        fontWeight: "600",
                        padding: "0 8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <i>
                        <img
                          src={svgImg2}
                          alt=""
                          style={{ width: "14px", marginRight: "4px" }}
                        />
                      </i>
                      <a
                        className="hover-anim"
                        href="mailto:contact@aquaprofessional.org"
                      >
                        contact@aquaprofessional.org
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12 d-flex justify-content-end">
                <div
                  className="ed-header-button d-flex justify-content-end align-items-center gap-2"
                  style={{ position: "relative" }}
                >
                  <div
                    className="auth-section"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "flex-end",
                      height: "100%",
                    }}
                  >
                    {auth ? (
                      <div
                        className="dropdown"
                        ref={dropdownRef}
                        style={{ position: "relative" }}
                      >
                        <button
                          className="ed-btn-theme d-none d-md-flex"
                          style={{
                            minWidth: "120px",
                            maxWidth: "140px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            padding: "6px 12px",
                            fontSize: "16px",
                            fontWeight: "500",
                            whiteSpace: "nowrap",
                            height: "40px",
                          }}
                          onClick={toggleDropdown}
                        >
                          <span>{getRoleDisplayText()}</span>
                          {dropdownOpen ? (
                            <ChevronUp
                              size={12}
                              style={{ marginLeft: "4px" }}
                            />
                          ) : (
                            <ChevronDown
                              size={12}
                              style={{ marginLeft: "4px" }}
                            />
                          )}
                        </button>

                        <button
                          className="ed-btn-theme d-md-none"
                          style={{
                            padding: "6px 12px",
                            fontSize: "14px",
                            minWidth: "80px",
                            height: "40px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            whiteSpace: "nowrap",
                          }}
                          onClick={toggleDropdown}
                        >
                          <span>{getRoleDisplayText()}</span>
                          {dropdownOpen ? (
                            <ChevronUp
                              size={10}
                              style={{ marginLeft: "4px" }}
                            />
                          ) : (
                            <ChevronDown
                              size={10}
                              style={{ marginLeft: "4px" }}
                            />
                          )}
                        </button>

                        <ul
                          className={`dropdown-menu ${
                            dropdownOpen ? "show" : ""
                          }`}
                          style={{
                            position: "absolute",
                            top: "100%",
                            right: 0,
                            zIndex: 1000,
                            background: "#fff",
                            padding: "4px 0",
                            borderRadius: "4px",
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                            listStyle: "none",
                            margin: "2px 0 0",
                            minWidth: "100px",
                            border: "1px solid #eee",
                            display: dropdownOpen ? "block" : "none",
                          }}
                        >
                          {auth.role === "admin" ||
                          auth.role === "maintainer" ? (
                            <li>
                              <Link
                                className="dropdown-item"
                                to="/admin/dashboard"
                                style={{
                                  padding: "4px 8px",
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#333",
                                  textDecoration: "none",
                                  fontSize: "16px",
                                }}
                                onClick={() => setDropdownOpen(false)}
                              >
                                <Gauge
                                  size={12}
                                  style={{ marginRight: "4px" }}
                                />
                                Dashboard
                              </Link>
                            </li>
                          ) : (
                            <li>
                              <Link
                                className="dropdown-item"
                                to={
                                  auth.role === "student"
                                    ? "/student-profile"
                                    : "/member-profile"
                                }
                                style={{
                                  padding: "4px 8px",
                                  display: "flex",
                                  alignItems: "center",
                                  color: "#333",
                                  textDecoration: "none",
                                  fontSize: "16px",
                                }}
                                onClick={() => setDropdownOpen(false)}
                              >
                                <User
                                  size={12}
                                  style={{ marginRight: "4px" }}
                                />
                                Profile
                              </Link>
                            </li>
                          )}
                          <li>
                            <button
                              className="dropdown-item"
                              onClick={() => {
                                logout();
                                setDropdownOpen(false);
                              }}
                              style={{
                                padding: "4px 8px",
                                display: "flex",
                                alignItems: "center",
                                width: "100%",
                                textAlign: "left",
                                background: "none",
                                border: "none",
                                color: "#333",
                                cursor: "pointer",
                                fontSize: "16px",
                              }}
                            >
                              <LogOut
                                size={12}
                                style={{ marginRight: "4px" }}
                              />
                              Logout
                            </button>
                          </li>
                        </ul>
                      </div>
                    ) : (
                      <Link
                        to="/login"
                        className="d-flex align-items-center"
                        style={{
                          padding: "6px 16px",
                          fontSize: "14px",
                          fontWeight: "500",
                          textDecoration: "none",
                          minWidth: "100px",
                          justifyContent: "center",
                          gap: "4px",
                          height: "45px",
                          backgroundColor: "#6c4af2",
                          borderRadius: "24px",
                          color: "#fff",
                        }}
                      >
                        Member Login <RightArrow />
                      </Link>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          id="header-sticky"
          className={
            isVisible
              ? "ed-header-area ed-header-ptb header-sticky"
              : "ed-header-area ed-header-ptb"
          }
          style={{ padding: "10px 0" }}
        >
          <div className="container-fluid px-3 px-md-4">
            <div className="ed-header-wrapper">
              <div className="row align-items-center">
                <div className="col-xl-3 col-lg-1 col-md-4 col-8">
                  <div className="ed-header-logo">
                    <Link to="/">
                      <img
                        src={Logo}
                        alt="logo"
                        style={{ maxHeight: "80px", width: "auto" }}
                      />
                    </Link>
                  </div>
                </div>

                <div className="col-xl-9 col-lg-7 d-none d-lg-block">
                  <div className="ed-header-main-menu it-main-menu text-center">
                    <nav className="it-menu-content">
                      <MenuItems />
                    </nav>
                  </div>
                </div>

                <div className="col-xl-2 col-lg-1 col-md-8 col-3 p-0 d-xl-none">
                  <div className="ed-header-button d-flex justify-content-end align-items-center gap-2 lg:mr-20">
                    <div className="ed-header-5-bar d-lg-none">
                      <button
                        className="it-menu-bar"
                        onClick={() => setIsOffCanvasOpen(true)}
                        style={{
                          background: "none",
                          border: "none",
                          padding: "6px",
                        }}
                      >
                        <svg
                          width="20"
                          height="16"
                          viewBox="0 0 24 20"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            fillRule="evenodd"
                            clipRule="evenodd"
                            d="M10 18.3333C10 17.4128 10.7462 16.6667 11.6667 16.6667H21.6667C22.5872 16.6667 23.3333 17.4128 23.3333 18.3333C23.3333 19.2538 22.5872 20 21.6667 20H11.6667C10.7462 20 10 19.2538 10 18.3333ZM0 1.66667C0 0.746183 0.746183 0 1.66667 0H21.6667C22.5872 0 23.3333 0.746183 23.3333 1.66667C23.3333 2.58713 22.5872 3.33333 21.6667 3.33333H1.66667C0.746183 3.33333 0 2.58713 0 1.66667ZM0 10C0 9.07953 0.746183 8.33333 1.66667 8.33333H21.6667C22.5872 8.33333 23.3333 9.07953 23.3333 10C23.3333 10.9205 22.5872 11.6667 21.6667 11.6667H1.66667C0.746183 11.6667 0 10.9205 0 10Z"
                            fill="#0E2A46"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      <div className="it-offcanvas-area">
        <div className={isOffCanvasOpen ? "itoffcanvas opened" : "itoffcanvas"}>
          <div className="itoffcanvas__close-btn">
            <button
              className="close-btn"
              onClick={() => setIsOffCanvasOpen(false)}
              style={{ padding: "8px" }}
            >
              <X size={16} />
            </button>
          </div>
          <div className="itoffcanvas__logo" style={{ padding: "15px 0" }}>
            <Link to="/">
              <img src={Logo} alt="logo" style={{ maxHeight: "60px" }} />
            </Link>
          </div>

          {auth && (
            <div
              className="mobile-auth-section"
              style={{
                padding: "12px 0",
                borderBottom: "1px solid #eee",
                margin: "0 15px",
              }}
            >
              <div style={{ textAlign: "center", marginBottom: "8px" }}>
                <span
                  style={{ fontWeight: "600", color: "#333", fontSize: "13px" }}
                >
                  {getRoleDisplayText()}
                </span>
              </div>
              <div style={{ textAlign: "center" }}>
                {auth.role === "admin" || auth.role === "maintainer" ? (
                  <Link
                    to="/admin/dashboard"
                    onClick={() => setIsOffCanvasOpen(false)}
                    style={{
                      display: "inline-block",
                      padding: "6px 12px",
                      backgroundColor: "#007bff",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "3px",
                      marginRight: "8px",
                      fontSize: "12px",
                    }}
                  >
                    Dashboard
                  </Link>
                ) : (
                  <Link
                    to={
                      auth.role === "student"
                        ? "/student-profile"
                        : "/member-profile"
                    }
                    onClick={() => setIsOffCanvasOpen(false)}
                    style={{
                      display: "inline-block",
                      padding: "6px 12px",
                      backgroundColor: "#007bff",
                      color: "white",
                      textDecoration: "none",
                      borderRadius: "3px",
                      marginRight: "8px",
                      fontSize: "12px",
                    }}
                  >
                    Profile
                  </Link>
                )}
                <button
                  onClick={() => {
                    logout();
                    setIsOffCanvasOpen(false);
                  }}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: "3px",
                    cursor: "pointer",
                    fontSize: "12px",
                  }}
                >
                  Logout
                </button>
              </div>
            </div>
          )}

          <div
            className="itoffcanvas__text"
            style={{ padding: "15px", fontSize: "13px" }}
          >
            <p>
              Society of Aquaculture Professionals was founded as a
              not-for-profit, non-governmental organization in 2003. SAP is the
              voice of aquaculture professionals in India.
            </p>
          </div>

          <div className="it-menu-mobile d-lg-none">
            <MenuItems mobileMenu="show" />
          </div>

          <div className="itoffcanvas__info" style={{ padding: "15px" }}>
            <h3
              className="offcanva-title"
              style={{ fontSize: "16px", marginBottom: "12px" }}
            >
              Get In Touch
            </h3>
            <div className="it-info-wrapper mb-15 d-flex align-items-center">
              <div
                className="itoffcanvas__info-icon"
                style={{ marginRight: "8px" }}
              >
                <Phone size={14} />
              </div>
              <div
                className="itoffcanvas__info-address"
                style={{ fontSize: "12px" }}
              >
                <span>Phone</span>
                <a href="tel:+919381944445">+91 93819 44445</a>
              </div>
            </div>
            <div className="it-info-wrapper mb-15 d-flex align-items-center">
              <div
                className="itoffcanvas__info-icon"
                style={{ marginRight: "8px" }}
              >
                <MapPin size={14} />
              </div>
              <div
                className="itoffcanvas__info-address"
                style={{ fontSize: "12px" }}
              >
                <span>Location</span>
                <a href="#">
                  2 & 3, PKM Cross Street, Chennai - 600 095, Tamil Nadu, India
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {isOffCanvasOpen && (
        <div
          className="body-overlay apply"
          onClick={() => setIsOffCanvasOpen(false)}
        ></div>
      )}
    </>
  );
};

export default Header;
